import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { Palette, Calendar, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth.jsx";
import { getNav } from "@/pages/navConfigs";

export default function DesignerDashboard() {
  const { user, customRole } = useAuth();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/designer/my-events");
        setEvents(r.data || []);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <Layout navItems={getNav(user.role, customRole)}>
      <div className="p-6 lg:p-10 max-w-7xl mx-auto" data-testid="designer-dashboard">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-fuchsia-500 to-pink-500 flex items-center justify-center text-white"><Palette className="w-6 h-6" /></div>
          <div>
            <h1 className="font-display font-black text-2xl text-slate-900">Designer Desk</h1>
            <p className="text-sm text-slate-500">Events where you're assigned. Open one to view the Social Media calendar and attach your design links.</p>
          </div>
        </div>

        {loading ? (
          <div className="dashboard-card p-12 text-center text-slate-400">Loading…</div>
        ) : events.length === 0 ? (
          <div className="dashboard-card p-12 text-center">
            <Palette className="w-10 h-10 text-slate-300 mx-auto mb-3" />
            <p className="text-slate-500 font-semibold">No events assigned yet</p>
            <p className="text-xs text-slate-400 mt-1">Admin, Regional PM or Project Manager can assign you to any event from its detail page.</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {events.map((e) => (
              <Link key={e.event_id} to={`/dashboard/design-events/${e.event_id}`} className="dashboard-card p-5 hover:border-fuchsia-300 transition-colors group" data-testid={`design-event-${e.event_id}`}>
                <div className="flex items-center gap-3">
                  <div className="w-14 h-14 rounded-2xl brand-gradient flex items-center justify-center text-white font-display font-black text-xl overflow-hidden">
                    {e.logo_url ? <img src={`${process.env.REACT_APP_BACKEND_URL}${e.logo_url}`} alt="" className="w-full h-full object-cover" /> : e.name?.charAt(0)}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-display font-bold text-slate-900 truncate">{e.name}</div>
                    <div className="text-xs text-slate-500">{e.school_name}</div>
                    <div className="text-xs text-slate-400 flex items-center gap-1 mt-1"><Calendar className="w-3 h-3" /> {e.start_date} → {e.end_date}</div>
                  </div>
                  <ArrowRight className="w-4 h-4 text-slate-300 group-hover:text-fuchsia-500" />
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
